<mat-toolbar class="secondary-toolbar mat-elevation-z1">
</mat-toolbar>

<section class="main-content">
  <form *ngIf="!account" [formGroup]="provisioningForm" (ngSubmit)="onProvision()">
    <div class="dashboard-tile">
      <div *ngIf="isSaving">
        <div style="padding-top:20px; width:100%; height:100%; position:absolute; z-index:200; background-color:rgba(0, 0, 0, 0.2); box-sizing: border-box;">
          <div style="margin: auto; width: 200px; padding:20px; background-color:white;">
            <div style="text-align:center;padding-bottom:10px;">Creating your account...</div>
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </div>
        </div>
      </div>
      <div class="tile-header">
        <div class="tile-header-title">
          Enable Assessments for your Connectwise Manage Account
        </div>
      </div>
      <div class="tile-content">
        <img mat-card-image class="tile-logo" src="{{themeManager.getStackedLogo()}}">
        <div>
          In order to create your assessments account, you must first create API credentials within Connectwise Manage. Please <a href="https://docs.connectwise.com/ConnectWise_Identify/003/010" target="_blank">see here</a> for instructions on how to do that.
        </div>
        <div *ngIf="provisioningForm.errors?.saveError">
          <mat-error>Your account could not be saved. Please correct the below errors before trying again.</mat-error>
        </div>
        <div class="formFieldList" style="width:50%; display:inline-block;">
          <div>Please enter your Connectwise Site information:</div>
          <mat-form-field>
            <input matInput formControlName="partnerDomain" placeholder="Connectwise Site" required>
            <mat-error *ngIf="provisioningForm.controls.partnerDomain?.errors?.connectionError">Could not connect to your site</mat-error>
          </mat-form-field>
          <mat-form-field>
            <input matInput formControlName="companyId" placeholder="Company Id" required>
            <mat-error *ngIf="provisioningForm.controls.companyId?.errors?.invalid">Could not find your company Id</mat-error>
          </mat-form-field>
          <mat-form-field>
            <input matInput formControlName="apiPublicKey" placeholder="API Public Key" required>
            <mat-error *ngIf="provisioningForm.controls.apiPublicKey?.errors?.invalid">API Public/Private key is invalid</mat-error>
            <mat-error *ngIf="provisioningForm.controls.apiPublicKey?.errors?.invalidPermissions">API key does not have sufficient permission</mat-error>
          </mat-form-field>
          <mat-form-field>
            <input matInput formControlName="apiPrivateKey" placeholder="API Private Key" type="password" required>
          </mat-form-field>
        </div>
        <div class="formFieldList" style="width:50%; display:inline-block;">
          <div>Assessments user registration information:</div>
          <mat-form-field>
            <input matInput placeholder="First Name" formControlName="userFirstName" required>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="Last Name" formControlName="userLastName" required>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="Email" formControlName="userEmail" email required>
            <mat-error *ngIf="provisioningForm.controls.userEmail?.errors?.notUnique">
              There is already an account
              registered to that email address.
            </mat-error>
            <mat-error *ngIf="provisioningForm.controls.userEmail?.errors?.email">Invalid email address</mat-error>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="Password" formControlName="userPassword" required type="password" pattern="^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$">
            <mat-hint>at least 8 characters, 1 uppercase, 1 lowercase, 1 number, and 1 special character</mat-hint>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="Confirm Password" formControlName="userConfirmPassword" required type="password">
            <mat-error *ngIf="provisioningForm.controls.userConfirmPassword?.errors?.passwordNoMatch">Doesn't match password</mat-error>
          </mat-form-field>

        </div>
        <div class="tile-footer centered">
          <button mat-raised-button color="primary" type="submit">Create Account</button>
          <button mat-raised-button color="primary" type="button" (click)="onRegister()">Non-Manage Registration</button>
        </div>
      </div>
    </div>
  </form>

  <div *ngIf="account">
    <div class="dashboard-tile">
      <div class="tile-header">
        <div class="tile-header-title">
          Success!
        </div>
      </div>
      <div class="tile-content">
        <img mat-card-image class="tile-logo" src="{{themeManager.getStackedLogo()}}">
        <div>Your assessments account has been created and setup with Manage.</div>
        <div>Please review the getting started guide on how to begin creating assessments.</div>
        <!-- <div class="text-warn" style="padding-top: 20px;margin-bottom: 9px;box-sizing: border-box;">Please keep a secure copy of the private key. After closing this window, it will not be accessible again.</div>
        <div style="padding:20px 10px;">
          <div>Public Key: <span class="text-primary">{{apiKey.publicKey}}</span></div>
          <div>Private Key: <span class="text-primary">{{apiKey.privateKeyHash}}</span></div>
        </div> -->
      </div>
    </div>
  </div>

</section>
